var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.456,
    y: 3.688,
    width: 3.763,
    height: 8.429,
    rx: 1,
    fill: "#92D3F5",
    stroke: "#000",
    strokeWidth: 0.644,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.58 12.25h5.474c.997 0 1.367-.555 1.364-1.255-.003-.638-.508-1.195-1.363-1.281.47.002 1.488-.11 1.488-1.11 0-.907-.344-1.256-1.136-1.256 0 0 .719-.094.719-1.198 0-1.201-1.68-1.103-2.179-1.103 0 0 1.196-.052 1.196-1.15 0-1.097-2.082-1.145-3.32-1.145-1.03 0-2.408-.04-3.63.224-1.223.265-2.501.822-2.973 1.344v7.362s2.86 1.748 3.288 4.189c.427 2.44 1.894 1.293 2.122-.154.228-1.447-.416-2.079-1.05-3.466z",
    fill: "#FCEA2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.58 12.25h5.474c.997 0 1.367-.555 1.364-1.255-.004-.694-.6-1.293-1.596-1.293m-5.242 2.549c.634 1.387 1.278 2.02 1.05 3.466-.228 1.447-1.695 2.595-2.122.154-.427-2.44-3.289-4.19-3.289-4.19V4.32c.473-.522 1.75-1.08 2.973-1.344 1.223-.264 2.601-.224 3.63-.224 1.239 0 3.321.048 3.321 1.145 0 1.098-1.196 1.15-1.196 1.15M10.58 12.25h-.697m3.991-2.549h1.948m-.875-4.655h-1.826 1.826zm0 0c.5 0 2.179-.098 2.179 1.103 0 1.104-.72 1.198-.72 1.198m0 0h-2.81 2.81zm0 0c.793 0 1.137.35 1.137 1.257 0 1.3-1.721 1.097-1.721 1.097",
    stroke: "#000",
    strokeWidth: 0.644,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgThumbsDown;